import React from "react";
import eggAud2 from "./egg2aud.mp3";

export default function Audplay2() {
  return (
    <audio controls src={eggAud2} autoPlay loop className="audio">
      Your browser does not support the
      <code>audio</code> element.
    </audio>
  );
}
